import { useTenantStore } from '@/stores/tenantStore';

// ky `beforeRequest` hook helper. Reads tenantId from the Zustand store and
// attaches it as `X-Tenant-Id` so the backend middleware can scope queries.
export function tenantInterceptor(request: Request): void {
  const tenantId = useTenantStore.getState().tenantId;
  if (tenantId) {
    request.headers.set('X-Tenant-Id', tenantId);
  }
}
